import clsx from 'clsx';

const VARIANTS = {
  primary: 'bg-ink text-white hover:bg-brand-hover disabled:bg-ink-faint',
  secondary: 'bg-surface-elevated text-ink border border-border-strong hover:bg-surface-subtle disabled:opacity-50',
  ghost: 'bg-transparent text-ink-muted hover:bg-surface-subtle hover:text-ink disabled:opacity-50',
  danger: 'bg-danger text-white hover:bg-danger/90 disabled:bg-ink-faint'
};

const SIZES = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-9 px-3.5 text-sm',
  lg: 'h-11 px-5 text-base'
};

export function Button({
  variant = 'primary',
  size = 'md',
  type = 'button',
  className,
  loading = false,
  disabled,
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors',
        VARIANTS[variant],
        SIZES[size],
        loading && 'cursor-progress',
        className
      )}
      {...rest}
    >
      {loading && (
        <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true" />
      )}
      {children}
    </button>
  );
}
